export default __webpack_public_path__ + "static/border-224b3a834d217e4218679821ac264f5e.png";